import type { EditOrderProps } from '@src/orders/EditOrder';
import type { EditOrderPage } from '@src/orders/EditOrderProvider';
import { EditOrderProvider } from '@src/orders/EditOrderProvider';

export type CompletePermitFormPage = (
  props: Omit<EditOrderProps, 'ActionsFooter' | 'onSubmit'> & {
    disabledFields: string[];
  },
) => JSX.Element;

interface Props {
  orderId: string;
  permitId: string;
  EditOrderPage: CompletePermitFormPage;
}

export const CompletePermitFormProvider = ({
  orderId,
  permitId,
  EditOrderPage,
}: Props) => {
  const PageWithDisabledFields: EditOrderPage = (props) => {
    const disabledFields = props.order.getFieldsHavingValuesInOtherPermits(
      permitId,
      props.client,
    );
    return (
      <EditOrderPage
        {...props}
        disabledFields={disabledFields}
        canAddPermits={false}
      />
    );
  };

  return (
    <EditOrderProvider
      orderId={orderId}
      EditOrderPage={PageWithDisabledFields}
    />
  );
};
